export default {"src":"/_next/static/media/dark-purple-to-light-purple-left.04faf012.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};